function getOrdenacao(nomeRecurso, linhaA, linhaB) {

    const prioridadePorcentA = parseFloat(linhaA.valorAtual) / parseFloat(linhaA.valorReferencia) * 100 || 0;
    const prioridadePorcentB = parseFloat(linhaB.valorAtual) / parseFloat(linhaB.valorReferencia) * 100 || 0;

    const recursosPorc = ['MONITOR_DISCO_BANCO'];
    const recursosValorBruto = ['MONITOR_MEMORIA', 'MONITOR_DISCO_WINDOWS'];
    const recursosCrescente = ['MONITOR_BLOCOX_ESTOQUE'];
    const regimeTributarioPrioritario = 'SIMPLES NACIONAL';
    const isSimplesNacional = linha => linha.regimeTributario === regimeTributarioPrioritario;

    if (recursosPorc.includes(nomeRecurso)) {
        return prioridadePorcentA - prioridadePorcentB;
    } else if (recursosValorBruto.includes(nomeRecurso)) {
        return linhaA - linhaB;
    } else if (recursosCrescente.includes(nomeRecurso)) {

        const ordenarPorId = linhaA.id - linhaB.id;
        return isSimplesNacional(linhaA) ? -1 : isSimplesNacional(linhaB) ? 1 : ordenarPorId;
    } else {
        return isSimplesNacional(linhaA) ? -1 : isSimplesNacional(linhaB) ? 1 : 0;
    }
}
export default getOrdenacao;
